import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);


// 조하늘 ..
export default new Vuex.Store({
  modules: {},
  state: {
    userId: "",
    newsList: []
  },
  getters: {
    getNewsList: state => {
      return state.newsList;
    }
  },
  mutations: {
    setNewsList: (state, payload) => {
      state.newsList = payload;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js